import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a0104c03"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "dialog-header" }
const _hoisted_3 = { class: "dialog-title" }
const _hoisted_4 = {
  key: 0,
  class: "dialog-icon"
}
const _hoisted_5 = { class: "dialog-body" }
const _hoisted_6 = {
  key: 0,
  class: "dialog-footer"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: "dialog-overlay",
    onClick: _withModifiers($setup.handleClose, ["self"])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["dialog-content", $setup.sizeClass])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          ($props.icon)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($props.icon), 1 /* TEXT */))
            : _createCommentVNode("v-if", true),
          _createTextVNode(" " + _toDisplayString($props.title), 1 /* TEXT */)
        ]),
        _createElementVNode("button", {
          class: "close-btn",
          onClick: $setup.handleClose
        }, "✕")
      ]),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ]),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
          ]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}